module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatment-tabs"
  }, [_c('div', {
    staticClass: "custom-treatment-tabs__container"
  }, [_c('div', {
    staticClass: "custom-treatment-tabs__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-treatment-tabs__body"
  }, [_c('div', {
    staticClass: "custom-treatment-tabs__tabs"
  }, [_vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "custom-treatment-tabs__tab",
      class: {
        'custom-treatment-tabs__tab--active': i === _vm.active
      },
      domProps: {
        "innerHTML": _vm._s(tab.title)
      },
      on: {
        "click": function($event) {
          _vm.active = i
        }
      }
    })
  }), _vm._l((_vm.props.tabs), function(content, j) {
    return (j === _vm.active) ? _c('div', {
      staticClass: "custom-treatment-tabs__content",
      class: {
        'custom-treatment-tabs__content--active': j === _vm.active
      }
    }, [_c('div', {
      staticClass: "custom-treatment-tabs__image",
      style: ({
        backgroundImage: 'url(' + content.image + ')'
      })
    }), _c('div', {
      staticClass: "custom-treatment-tabs__text",
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    })]) : _vm._e()
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e5ea26a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-treatment-tabs/custom-treatment-tabs.pug
// module id = 655
// module chunks = 1